import { connect } from 'react-redux';
import React, { useRef,useEffect, useState } from 'react'
import './App.css';
import { Routes, Route, useLocation, useSearchParams } from 'react-router-dom'
//Screens
import Home from './screens/Home'
import AboutUs from './screens/AboutUs';
import Register from './screens/Register';
import Special from './screens/Special'
//
import RightNavBar from './components/RightNavBar.js'
function App() {
  const scrollRef = useRef(null);
  const location = useLocation()
  const [rightNav, setRightNav] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const handleSetRightNav = (bool) => setRightNav(bool)
  useEffect(() => { 
    setTimeout(() => {
      scrollRef.current.scrollTo(0, 0)
    }, 10)
  }, [location])
  useEffect(() => {
    const handleResize = () => {
        setIsMobile(window.innerWidth < 768);
    };

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => {
        window.removeEventListener('resize', handleResize);
    };
}, []);
  return (
    <div className={`flex h-[100vh] h-min-[100vh] w-[100vw] w-min-[100vw] flex flex-col items-center justify-center App relative`}>
        <RightNavBar rightNav={rightNav} setRightNav={setRightNav} handleSetRightNav={handleSetRightNav}/>
        {/* <div className='fixed top-0 left-0 w-[100vw] h-[100vh] bg-[#01A334] z-50' style={{opacity:0.5, zIndex:99999999999999999999999}}>

        </div> */}
        <div ref={scrollRef} className='w-[100%] flex flex-col overflow-y-auto overflow-x-hidden'>
          <Routes>
            <Route path="/" element={<Home isMobile={isMobile} scrollRef={scrollRef} handleSetRightNav={handleSetRightNav}/>} />
            <Route path="/aboutus" element={<AboutUs scrollRef={scrollRef} handleSetRightNav={handleSetRightNav}/>} />
            <Route path="/specialties" element={<Special scrollRef={scrollRef} handleSetRightNav={handleSetRightNav}/>} />
            <Route path="/register" element={<Register scrollRef={scrollRef} handleSetRightNav={handleSetRightNav}/>} />
          </Routes>
        </div>
    </div>
  );
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(App)

